import { SP_addProductToShoppingCart, SP_getCurrentShoppingCart } from '../layouts/shopping_cart.js';
$(document).on('click', '#related-products-list .product-list-item .quantity-down', downQuantity);
$(document).on('click', '#related-products-list .product-list-item .quantity-up', upQuantity);
$(document).on('click', '#related-products-list .product-list-item-size', changeProductSize);
$(document).on('click', '#related-products-list .product-list-item .add-to-shopping-cart', addRelatedProductToShoppingCart);
$(document).on('click', '.product-galery-item', changePrincipalProductImage);
$(document).on('click', '#product-buy-container', addProductToShoppingCart);
$(document).on('click', '#product-size-list .product-size-list-item', selectProductSize);
$(document).on('click', '#color-input-list .dropdown-item-p', selectProductColor);
$(document).on('click', '#product-quantity-sub-container .fa-chevron-down', decreaseProductQuantity);
$(document).on('click', '#product-quantity-sub-container .fa-chevron-up', increaseProductQuantity);

var currentSizeList = null;
var currentSize = null;
var currentColorList = null;
var currentColor = null;
var addingToShoppingCartFlag = false;
var currentCategories = [];
let products_array = [];

$(document).ready(function(){
  getProductGalery();
  getProductBrands();
  getProductSizes();
  getProductCategories();
  //getProductColors();
});
function getProductGalery(){
  var DataSend = {
    'product_id': currentProduct.id
  }
  PostMethodFunction('/Catalogue/Product/Galery/Get', DataSend, null , showProductGalery, null);
}
function showProductGalery(result){
  let counter = 0;
  let AppendContent = '';
  $.each(result.data, function(index, product){
    if(counter > 0){
      AppendContent += '<li class="product-galery-item" style="background-image: url(\'/'+product.path+'\')">';
      AppendContent += '</li>';
    }else{
      $('#product-galery-principal').css('background-image', 'url(\'/'+product.path+'\')');
    }
    counter++;
  });
  $('#product-galery-list').empty().append(AppendContent);
}
function changePrincipalProductImage(){
  let principalImage = $('#product-galery-principal').css('background-image');
  let newImage = $(this).css('background-image');
  $('#product-galery-principal').css('background-image', newImage);
  $(this).css('background-image', principalImage);
}
function getProductBrands(){
  var DataSend = {
    product_id: currentProduct.id
  }
  PostMethodFunction('/Catalogue/Product/Brand/Get', DataSend, null , showProductBrands, null);
}
function showProductBrands(result){
  let brandsString = '';
  $.each(result.data, function(index, brand){
    if(brand.associated != null && brand.associated.status == 1){
      brandsString += brand.name + ', ';
    }
  });
  brandsString = brandsString.substring(0, brandsString.length - 2);
  if(brandsString != ''){
    $('#product-brands').empty().text(brandsString);
  }
    
}
function getProductSizes(){
  var DataSend = {
    product_id: currentProduct.id
    ,check_quantities: false
  }
  PostMethodFunction('/Catalogue/Product/Size/Get', DataSend, null , showProductSizes, null);
}
function showProductSizes(result){
  currentSizeList = result.data.length>0 ? result.data : [];
  let AppendContent = '';
  $.each(result.data, function(index, size){
    AppendContent += '<li class="product-size-list-item badge" value="'+size.id+'">'+size.size+'</li>';
  }
  );
  $('#product-size-list').empty().append(AppendContent);
  if(result.data.length>0){
    $('#product-size-list .product-size-list-item[value="'+result.data[0].id+'"]').click();
  }
}

function getProductColors(){
  var DataSend = {
    product_id: currentProduct.id
  }
  PostMethodFunction('/Catalogue/Product/Color/Get', DataSend, null , showProductColors, null);
}
function showProductColors(result){
  $('#product-quantity-container #color-input-container').remove();
  if(result.data.length>0){
    currentColorList = result.data;
    let AppendContent = '<div class="col-12 col-md-7 m-0 p-0" id="color-input-container">';
      AppendContent += '<div class="input-group">';
            AppendContent += '<div class="col dropdown" value="0" id="color-input">';
                AppendContent += '<div class="dropdown-btn dropdown-toggle d-flex align-items-center" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">';
                    AppendContent += '<p class="dropdown-btn-text d-inline-block py-0 my-0">SELECCIONAR UN COLOR</p>';
                AppendContent += '</div>';
                AppendContent += '<div class="dropdown-menu" id="color-input-list">';
                  $.each(result.data, function(index, color){
                    AppendContent += '<p class="dropdown-item dropdown-item-p" value="'+color.id+'">'+color.color+'</p>';
                  });
                AppendContent += '</div>';
            AppendContent += '</div>';
        AppendContent += '</div>';
    AppendContent += '</div>';
    $('#product-quantity-container').append(AppendContent);
  }
  
}
function selectProductSize(){
  $('.product-size-list-item').removeClass('active');
  $(this).addClass('active');
  currentSize = $(this).attr('value');
  let sizeData = currentSizeList.find(size => size.id == currentSize);
  if(sizeData != null){
    if(currentProduct.discount != null && currentProduct.discount != undefined && currentProduct.discount.discount > 0){ 
      $('#product-price').text('$'+(sizeData.price * (1-(currentProduct.discount.discount/100))).toLocaleString().replace(',', '.') + ' COP');
      $('#product-normal-price').text('$'+sizeData.price.toLocaleString().replace(',', '.') + ' COP');
    }else{
      $('#product-price').text('$'+sizeData.price.toLocaleString().replace(',', '.') + ' COP');
    }
  }
}
function addProductToShoppingCart(){
  if(!addingToShoppingCartFlag){
    let flag = true;
    let product_id = currentProduct.id;
    let quantity = $('#product-quantity-input').val();
    let size = currentSize;
    let color = currentColor;
    if(quantity == '' || quantity == null || quantity == undefined || quantity < 1){
      flag = false;
      alertWarning('Debe ingresar una cantidad válida');
    }
    if(currentSizeList != null && size == null){
      flag = false;
      alertWarning('Debe seleccionar una presentación');
    }
    /*if(currentColorList != null && color == null){
      flag = false;
      alertWarning('Debe seleccionar un color');
    }*/
    if(flag){
      addingToShoppingCartFlag = true;
      SP_addProductToShoppingCart(product_id, quantity, size, color, addProductToShoppingCartSuccess);
    }
  }
}
function addProductToShoppingCartSuccess(response){
  addingToShoppingCartFlag = false;
  if(response!= null){
    $('#product-quantity-input').val(1);
  }
}
function selectProductColor(){
  currentColor = $('#color-input').attr('value');
}
function decreaseProductQuantity(){
  let quantity = $('#product-quantity-input').val();
  if(quantity > 1){
    $('#product-quantity-input').val(quantity-1);
  }
  SP_getCurrentShoppingCart();
}
function increaseProductQuantity(){
  let quantity = $('#product-quantity-input').val();
  $('#product-quantity-input').val(parseInt(quantity)+1);
  SP_getCurrentShoppingCart();
}
function getProductCategories(){
  var DataSend = {
    product_id: currentProduct.id
  }
  PostMethodFunction('/Catalogue/Product/Category/Get', DataSend, null , showProductCategories, null);
}
function showProductCategories(result){
  currentCategories = result.data.length>0 ? result.data : [];
  let categoriesString = '';
  $.each(currentCategories, function(index, category){
    if(category.sub_categories.filter(x => x.associated != null).length>0){
      category.sub_categories.forEach(element => {
        categoriesString += element.name + ', ';  
      });
    }
  });
  categoriesString = categoriesString.substring(0, categoriesString.length - 2);
  if(categoriesString != ''){
    $('#product-categories').empty().text(categoriesString);
  }
  getRelatedProducts();
}
function getRelatedProducts(){
  let currentCategoriesIds = currentCategories.map(x => x.id);
    let data = {
        pagination: {
          page: 1,
          size: 10,
          total: 0,
          totalPages:0
        },
        category_ids: currentCategoriesIds,
        brand_ids: ['all'],
        order_id: 'relevance',
        stock_id: null,
        search: '',
        exclude_ids: [currentProduct.id]
    };
    PostMethodFunction('/WebPage/Catalogue/Product/GetPage',data, null, showRelatedProducts, function(){});
}
function showRelatedProducts(response){
  products_array = response.data;
  let appendContent = '';
  let product_image_path = '';
  $.each(products_array, function(index, item){
      appendContent += '<li class="product-list-item" product-id="'+item.id+'">';
          if(item.images.length  == 0){
              product_image_path = '/images/product/no-image.png';
          }else{
              //select random image path
              product_image_path = item.images[Math.floor(Math.random() * item.images.length)].path;
          }
          appendContent += '<div class="product-list-item-image" style="background-image: url(\'/'+product_image_path+'\');"></div>';
          appendContent += '<h2 class="product-list-item-title">'+item.name+'</h2>';
          appendContent += '<div class="product-list-item-categories-container mb-0 mt-auto">';
              $.each(item.categories, function(index, category){
                  appendContent += '<p class="product-list-item-category">'+category.name+(index==item.categories.length-1?'.':',')+'</p>';
              });
          appendContent += '</div>';
          appendContent += '<div class="product-list-item-sizes-container my-0">';
              $.each(item.sizes, function(index, size){
                  appendContent += '<span class="product-list-item-size badge '+(index==0?'selected':'disabled')+'" size-id="'+size.id+'" title="'+size.size+'">'+size.size+'</span>';
              });
          appendContent += '</div>';
          appendContent += '<div class="product-list-item-price-container d-flex justify-content-start my-0">';
              if(item.has_discount == true) appendContent += '<span class="align-self-center product-list-item-price-discount"></span>';
              appendContent += '<span class="align-self-center product-list-item-price"></span>';
          appendContent += '</div>';
          appendContent += '<div class="product-list-item-buttons-container d-flex justify-content-between my-0">';
              appendContent += '<a href="/products/'+item.url+'" class="product-list-item-view d-flex justify-content-center"><i class="fa-solid fa-eye align-self-center"></i></a>';
              appendContent += '<div class="product-list-item-quantity-container d-flex justify-content-between">';
                  appendContent += '<i class="fa-solid fa-chevron-down align-self-center quantity-down"></i>';
                  appendContent += '<input type="number" class="text-center align-self-center product-list-item-input" value="1" min="1" title="Cantidad">';
                  appendContent += '<i class="fa-solid fa-chevron-up align-self-center quantity-up"></i>';
              appendContent += '</div>';
              appendContent += '<button class="product-list-item-shopping-cart d-flex justify-content-center add-to-shopping-cart" title="Ver"><i class="fa-solid fa-cart-shopping align-self-center"></i></button>';
          appendContent += '</div>';
      appendContent += '</li>';
  });
  $('#related-products-list').html(appendContent);
  $.each($('#related-products-list .product-list-item'), function(index, item){
      showProductPrice($(item));
  });
}
function downQuantity(){
  let input = $(this).parent().find('.product-list-item-input');
  let value = parseInt(input.val());
  if(value > 1){
      input.val(value-1);
  }
}
function upQuantity(){
  let input = $(this).parent().find('.product-list-item-input');
  let value = parseInt(input.val());
  input.val(value+1);
}
function changeProductSize(){
  let container = $(this).parent().parent();
  $(this).parent().find('.product-list-item-size').removeClass('selected').addClass('disabled');
  $(this).addClass('selected').removeClass('disabled');
  showProductPrice(container);
}
function showProductPrice(container){
  let product_id = container.attr('product-id');
  let selected_size = container.find('.product-list-item-size.selected');
  //get product size info
  let product = products_array.find(x => x.id == product_id);
  if(product == null) return;
  let product_size = product.sizes.find(x => x.id == selected_size.attr('size-id'));
  if(product_size == null) return;
  if(product.has_discount == true){
    if(product_size.original_price==null || product_size.original_price==undefined){
      product_size.original_price = product_size.price;
    }
    product_size.price = product_size.price - (product_size.price * (product.discount.discount/100));
    container.find('.product-list-item-price-discount').html('$'+product_size.original_price.toLocaleString().replace(',', '.')+' COP');
    container.find('.product-list-item-price').html('$'+product_size.price.toLocaleString().replace(',', '.')+' COP');
  }else{
      container.find('.product-list-item-price-discount').html('');
      container.find('.product-list-item-price').html('$'+product_size.price.toLocaleString().replace(',', '.')+' COP');
  }
  
}
function addRelatedProductToShoppingCart(){
  let container = $(this).parent().parent();
  let product_id = container.attr('product-id');
  let quantity = container.find('.product-list-item-input').val();
  let size_id = container.find('.product-list-item-size.selected').attr('size-id');
  SP_addProductToShoppingCart(
      product_id,
      quantity,
      size_id,
      null,
      function(response){
          container.find('.product-list-item-input').val('1');
          SP_getCurrentShoppingCart();
      }
  );
}